export default __webpack_public_path__ + "static/media/alumni_project.fa4516b5.png";